import { Component, OnInit } from '@angular/core';
import { PlausibleService } from './plausible.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  numImagesToLoad = 1;

  imgLoadedCount = 0;

  hasLoaded = true;

  constructor(public plausible: PlausibleService) {}

  ngOnInit() {
    this.imgLoadedCount = 0;
  }

  countLoadedImage = (event:any) => {
    console.log('image loaded', event);
    this.imgLoadedCount ++;
    if(this.imgLoadedCount >= this.numImagesToLoad) {
      this.hasLoaded = true;
    }
  }


}
